import { Send as SendIcon } from '@project-lary/react-material-symbols-400-rounded';
import { Button, type ButtonProps, ButtonSize, ButtonVariant } from 'gcs-common/design-system/ui/button';

type Props = Omit<ButtonProps, 'Icon'> & {
  ariaLabel?: string;
};

function SendButton({
  ariaLabel = 'send',
  type = 'button',
  size = ButtonSize.l,
  variant = ButtonVariant.solid_accent,
  ...props
}: Props) {
  return <Button aria-label={ariaLabel} type={type} size={size} variant={variant} Icon={SendIcon} {...props} />;
}

export default SendButton;
